import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "./api";
import queryString from "query-string";

export const api = createApi({
  reducerPath: "hospitalApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Hospital"],
  endpoints: (builder) => ({
    getHospitals: builder.query({
      query: (filters) => `/hospitals?${queryString.stringify(filters)}`,
      providesTags: ["Hospital"],
    }),
    getHospital: builder.query({
      query: (id: string) => `/hospitals/${id}`,
      providesTags: (result, error, id) => [{ type: "Hospital", id }],
    }),
    createHospital: builder.mutation({
      query: (hospitalData) => ({
        url: "/hospitals",
        method: "POST",
        body: hospitalData,
      }),
      invalidatesTags: ["Hospital"],
    }),
    updateHospital: builder.mutation({
      query: (hospitalData) => ({
        url: `/hospitals/${hospitalData._id}`,
        method: "PUT",
        body: hospitalData,
      }),
      invalidatesTags: ["Hospital"],
    }),
    deleteHospital: builder.mutation({
      query: (id: string) => ({
        url: `/hospitals/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Hospital"],
    }),
  }),
});

export const {
  useGetHospitalsQuery,
  useGetHospitalQuery,
  useCreateHospitalMutation,
  useUpdateHospitalMutation,
  useDeleteHospitalMutation,
} = api;
